import React from 'react';
import {
  getDiffAbsoluteDays,
  formatDate,
} from 'Components/widgets/transport-details/transportUtils';
import { t } from 'Src/i18n';
type TransportDetailsTravelDatesProps = {
  transportDetailEnriched: TransportDetailEnriched;
  isInbound?: boolean;
};
export function TransportDetailsTravelDates({
  transportDetailEnriched,
  isInbound,
}: TransportDetailsTravelDatesProps) {
  const wayLabel = isInbound ? t('booking.transport.inbound') : t('booking.transport.outbound');
  const arrivalDaysAfter = getDiffAbsoluteDays(
    transportDetailEnriched.departure?.date,
    transportDetailEnriched.arrival?.date,
  );
  return (
    <div className="mb-2 flex text-14" data-testid="TransportDetailsTravelDates">
      <p className="font-semibold">{wayLabel}</p>
      &nbsp;
      <span>
        {formatDate(
          transportDetailEnriched.departure.date,
          t('booking.priceDetails.packagePrice.dateFormat'),
        )}
        {arrivalDaysAfter ? (
          <React.Fragment>
            &nbsp;
            <span className="font-semibold text-sienna">
              {`(${t('booking.transport.arrivalNextDay')} ${formatDate(transportDetailEnriched.arrival.date, t('booking.priceDetails.packagePrice.dateFormat'))})`}
            </span>
          </React.Fragment>
        ) : null}
      </span>
    </div>
  );
}
